//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "science",
    data() {
        return {
            list: [],
            id: '',
            downloadUrl: util.ApiUrl + '/file/download/',
        }
    },
    methods: {
        getContentByNodeName() {
            abp.ajax.get('/api/services/app/Content/GetAllContentByName?name=' + '科普知识').then((res) => {
                this.list = [];
                this.list.push(...res.data.result);
            });
        },
        getGraphicInformationByBusiness(id) {
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + id + '&businessType=content.remarks').then(res => {
                this.content = [];
                this.content = res.data.result;
                // console.log(res.data);
            })
        },
        listClicked(list) {
            this.$router.push('/serveMsgDetail/' + list.id);
        },
    },
    created() {
        this.getContentByNodeName();

    }
}
